import React from 'react'
import { Route, Redirect } from 'react-router-dom'

function AdminRoute({ component: Component, ...rest }) {
  const isAuthenticated = localStorage.getItem('adminData') !== null

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/admin/login" />
      }
    />
  )
}

export default AdminRoute
